import { render, staticRenderFns } from "./quotaLog.vue?vue&type=template&id=64a7c059&scoped=true"
import script from "./quotaLog.vue?vue&type=script&lang=js"
export * from "./quotaLog.vue?vue&type=script&lang=js"
import style0 from "./quotaLog.vue?vue&type=style&index=0&id=64a7c059&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7c059",
  null
  
)

export default component.exports